"use client";

import cn from "classnames";
import { ActionBarDrawerActions as ActionBarDrawerCTAType } from "@/src/type/strapi/component/object/ActionBarDrawerActions";
import { ActionBarDrawerPosition } from "@/src/type/strapi/component/partial/ActionBarDrawer";

import styles from "./ActionBarDrawer.module.scss";
import { BaseButton } from "../../base/BaseButton";
import Image from "next/image";
import { IconButton } from "@mui/material";

interface ActionBarDrawerActionsProps {
  actions: ActionBarDrawerCTAType;
  position: ActionBarDrawerPosition;
  openChat: () => void;
  openScheduleTour: () => void;
  className?: string;
}

function ActionBarDrawerActions({ actions, position, openChat, openScheduleTour, className }: ActionBarDrawerActionsProps) {
  return (
    <div className={cn(styles.actionBarDrawerActions, styles[`position-${position}`], className)}>
      {actions.showChatCta && (
        <IconButton
          className={styles.iconButton}
          onClick={openChat}
        >
          <Image
            src="/image/icon_chat.svg"
            width={24}
            height={24}
            className={styles.icon}
            alt="Chat Icon"
            priority={true}
          />
        </IconButton>
      )}
      {actions.showPhoneCta && (
        <IconButton
          href="tel:1234567890"
          className={styles.iconButton}
        >
          <Image
            src="/image/icon_phone_light.svg"
            width={24}
            height={24}
            className={styles.icon}
            alt="Phone Icon"
            priority={true}
          />
        </IconButton>
      )}
      {actions.showScheduledTourCta && (
        <BaseButton
          onClick={openScheduleTour}
          size="small"
          className={styles.scheduleTourButton}
          variant={actions.scheduledTourVariant}
        >
          {actions.scheduledTourTitle}
        </BaseButton>
      )}
    </div>
  );
}

export default ActionBarDrawerActions;
